export default "__VITE_ASSET__DohKALYi__"